import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuth } from './AuthContext';

/** Route wrapper: anonymous users go to /login and come back to the page they asked for. */
export function RequireAuth() {
    const { user } = useAuth();
    const location = useLocation();
    if (!user) {
        return <Navigate to="/login" replace state={{ from: location.pathname }} />;
    }
    return <Outlet />;
}
